<template>
  <div class="accountsReceiveTotal">
    <div class="accountsReceiveTotalWrap">
      <el-form
        :inline="true"
        :model="searchForm"
        ref="searchForm"
        style="height: 40px; margin-top: 10px"
        v-if="!isFullscreen"
        label-width="70px"
      >
        <el-row>
          <el-col :span="5">
            <el-form-item label="项目部" prop="deptId">
              <el-select
                v-model="searchForm.deptId"
                placeholder="请选择"
                @change="changeDept"
              >
                <el-option
                  v-for="item in deptIdList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="项目名称" prop="projectId">
              <el-select
                v-model="searchForm.projectId"
                placeholder="请选择"
                clearable
                @change="changeProject"
              >
                <el-option
                  v-for="item in projectIdList"
                  :key="item.projectId"
                  :label="item.projectName"
                  :value="item.projectId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="日期">
              <el-date-picker
                v-model="searchForm.monthDate"
                value-format="yyyy-MM"
                type="month"
                :picker-options="pickerOptions"
                placeholder="请选择"
                :clearable="false"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="项目状态" prop="projectProcess">
              <el-select
                v-model="searchForm.projectProcess"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="process in processStatusListForSelect"
                  :key="process.id"
                  :label="process.value"
                  :value="process.label"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <div
              label-width="0"
              style="text-align: center; width: 100%; white-space: nowrap"
              class="btnClass"
            >
              <el-button type="primary" @click="searchAll">查询</el-button>
              <el-button type="info" @click="reset">重置</el-button>
              <!-- <el-button type="primary" @click="changeSource">数据源</el-button> -->
              <div class="enlarge" @click="deptSet" v-if="!searchForm.deptId">
                <i class="el-icon-setting"></i>
              </div>
              <div class="enlarge" @click="enlargeClick">
                <i class="el-icon-zoom-in"></i>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <el-form
        :inline="true"
        style="height: 40px; margin-top: 10px; text-align: right"
        v-else
      >
        <el-form-item label style="float: right">
          <div class="enlarge" @click="narrowClick">
            <i class="el-icon-zoom-out"></i>
          </div>
        </el-form-item>
      </el-form>
      <el-divider></el-divider>
      <dataCenter21
        ref="dataCenter21"
        v-show="dataSource === 21"
      ></dataCenter21>
      <dataCenter22
        ref="dataCenter22"
        v-show="dataSource === 22"
      ></dataCenter22>
      <dataCenter23
        ref="dataCenter23"
        v-show="dataSource === 23"
      ></dataCenter23>
    </div>
    <deptSet ref="deptSeting" @getDept="refreshDept"></deptSet>
  </div>
</template>

<script>
import {
  getProcessStatusList, //获取项目状态下拉列表数据
} from "../../services/financeService";
import {
  getReceiveMaxDate,
  getReceiveDropDownProject,
} from "../../services/dataCenterAService";
import {
  getsubDeptService, //获取项目部二级项目级联列表
} from "@/services/sysSettingService";
import dataCenter21 from "./accountsReceivable";
import dataCenter22 from "./accountsReceiveDeptDataSingle";
import dataCenter23 from "./accountsReceiveData";
import deptSet from "./setDeptDialog";

export default {
  name: "accountsReceiveTotal",
  components: { dataCenter23, dataCenter22, dataCenter21, deptSet },
  data() {
    return {
      dataSource: 21,
      searchForm: {
        deptId: "",
        deptName: "",
        projectId: "",
        projectName: "",
        monthDate: "",
        projectProcess: "",
      },
      processStatusListForSelect: [], //项目状态的可选项
      deptIdList: [],
      projectIdList: [],
      pickerOptions: {
        disabledDate: this.disabledDate,
      },
      maxDate: "",
      isFullscreen: false,
      resizeTimer1: null,
    };
  },
  activated() {
    let _this = this;
    if (_this.resizeTimer1) clearTimeout(_this.resizeTimer1);
    _this.resizeTimer1 = setTimeout(function () {
      _this.setWrapWH30();
    }, 50);
  },
  beforeDestroy(){
    if (this.resizeTimer1) clearTimeout(this.resizeTimer1);
  },
  mounted() {
    let _this = this;
    this.setWrapWH30();
    this.getProcessStatusListForSelect();
    // window.onresize = () => {
    //     return (() => {
    //         this.setWrapWH30()
    //     })();
    // };
    window.addEventListener("resize", function () {
      // this.setWrapWH30()
      if (_this.resizeTimer1) clearTimeout(_this.resizeTimer1);
      _this.resizeTimer1 = setTimeout(function () {
        _this.setWrapWH30();
      }, 50);
    });
    this.isFullscreen = false;
    if (
      this.$route.params &&
      (this.$route.params.deptId ||
        this.$route.params.projectId ||
        this.$route.params.monthDate)
    ) {
      this.isFullscreen = true;
      this.fullScreen();
    }
    //获取日期
    getReceiveMaxDate().then((res) => {
      if (res.code === 10000000) {
        _this.searchForm.monthDate = res.data;
        this.maxDate = res.data;
        setTimeout(() => {
          this.searchAll();
        }, 10);
      }
    });
    //获取项目部
    this.getDept();
    //获取项目
    // this.getProject();
    this.bus.$on("navMenuChange", (nav) => {
      if (nav === "accountsReceivable") {
        _this.setWrapWH30();
      }
    });
  },
  methods: {
    refreshDept() {
      this.getDept();
      this.searchAll();
    },
    setWrapWH30() {
      //外面div大小
      let ch = document.documentElement.clientHeight;
      let cw = document.documentElement.clientWidth - 40;
      // 里面的div大小
      let chw = document.documentElement.clientHeight;
      let cww = document.documentElement.clientWidth - 40;
      //console.log('先',cw, ch,cww,chw)
      if (document.getElementById("aside")) {
        // ch = ch - 50 - 90
        ch = ch - 50 - 30;
        cw = cw - 280;
        chw = chw - 50 - 30;
        cww = cww - 280;
      }
      //console.log('中',cw, ch,cww,chw)
      if (chw < 800) {
        chw = 800;
      }
      if (cww < 1600) {
        cww = 1600;
      }
      //console.log('后',cw, ch,cww,chw)
      document.getElementsByClassName("accountsReceiveTotal")[0].style.height =
        ch + "px";
      setTimeout(() => {
        this.setWrapWH301();
      }, 30);
      // console.log('父组件onresize方法')
    },

    setWrapWH301() {
      try {
        if (this.searchForm.projectId) {
          this.dataSource = 23;
          this.$refs.dataCenter23.setWrapHeight();
        } else if (this.searchForm.deptId) {
          this.dataSource = 22;
          this.$refs.dataCenter22.setWrapHeight();
        } else {
          this.dataSource = 21;
          this.$refs.dataCenter21.setWrapHeight21();
        }
      } catch (err) {
        console.log(err);
      }
    },
    disabledDate(time) {
      // return time.getTime() > new Date(this.maxDate);
      return false;
    },
    searchAll() {
      this.setWrapWH30();
      if (this.$route.params && this.$route.params.monthDate) {
        this.searchForm.monthDate = this.$route.params.monthDate;
        this.$route.params.monthDate = "";
      }
      if (this.$route.params && this.$route.params.deptId) {
        this.searchForm.deptId = this.$route.params.deptId;
        this.$route.params.deptId = "";
      }
      if (this.$route.params && this.$route.params.projectId) {
        this.searchForm.projectId = this.$route.params.projectId;
        this.$route.params.projectId = "";
      }
      if (this.$route.params && this.$route.params.projectProcess) {
        this.searchForm.projectProcess = this.$route.params.projectProcess;
        this.$route.params.projectProcess = "";
      }
      if (!this.searchForm.monthDate) {
        return;
      }
      if (this.searchForm.projectId) {
        this.dataSource = 23;
        // this.$refs.dataCenter23.setWrapHeight();
        this.$refs.dataCenter23.search(this.searchForm);
      } else if (this.searchForm.deptId) {
        this.dataSource = 22;
        // this.$refs.dataCenter22.setWrapHeight();
        this.$refs.dataCenter22.search(this.searchForm);
      } else {
        this.dataSource = 21;
        // this.$refs.dataCenter21.setWrapHeight();
        this.$refs.dataCenter21.search(this.searchForm);
      }
    },
    reset() {
      this.$refs["searchForm"].resetFields();
      this.projectIdList = [];
    },
    //获取项目状态下拉列表
    getProcessStatusListForSelect() {
      getProcessStatusList()
        .then((res) => {
          if (res.code == "10000000") {
            this.processStatusListForSelect = res.data || [];
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch((error) => {
          this.$alert(error instanceof Error ? error.message : error, "提示");
        });
    },

    getDept() {
      let param = {};
      param.deptId = 101;
      getsubDeptService(param).then((res) => {
        if (res.code == 10000000) {
          this.deptIdList = res.data;
          // this.getDeptData();
        }
      });
    },
    getProject() {
      let params = {};
      if (this.searchForm.deptId) {
        params.deptId = this.searchForm.deptId;
      }
      getReceiveDropDownProject(params)
        .then((res) => {
          if (res.code === 10000000) {
            this.projectIdList = res.data || [];
          } else {
            this.projectIdList = [];
          }
        })
        .catch(() => {});
    },
    //切换数据源
    changeSource() {
      let memberData = {};
      this.bus.$emit("navMenuChange", {
        routeId: "accountsReceiveDataSource",
        routeParam: memberData,
      });
    },
    //切换项目部
    changeDept() {
      let index = this.deptIdList.findIndex(
        item => item.id === this.searchForm.deptId
      );
      this.searchForm.deptName = this.deptIdList[index].name;
      this.searchForm.projectId = "";
      this.getProject();
    },
    //切换项目名称
    changeProject() {
      let index = this.projectIdList.findIndex(
        (item) => item.projectId === this.searchForm.projectId
      );
      if (index !== -1) {
        this.searchForm.projectName = this.projectIdList[index].projectName;
      }
      // this.searchForm.projectName = this.projectIdList[index].projectName;
    },
    //设置部门
    deptSet() {
      // this.showFlag=true;
      this.$refs.deptSeting.showDeptDialog('RECEIPT');
    },
    //放大
    enlargeClick() {
      this.$router.push({
        name: "accountsReceiveTotalA",
        params: this.searchForm,
      });
      // let routeUrl = this.$router.resolve({
      //     name: 'accountsReceiveTotal', params: this.searchForm
      // });
      // window.open(routeUrl .href, '_blank');
      this.fullScreen();
    },
    fullScreen() {
      let el = document.documentElement;
      let rfs =
        el.requestFullScreen ||
        el.webkitRequestFullScreen ||
        el.mozRequestFullScreen ||
        el.msRequestFullscreen;
      if (typeof rfs != "undefined" && rfs) {
        rfs.call(el);
      }
      return;
    },
    //    取消F11缩小
    narrowClick() {
      this.$router.back();
      let el = document.documentElement;
      let cfs =
        el.requestFullScreen ||
        el.webkitRequestFullScreen ||
        el.mozRequestFullScreen ||
        el.msRequestFullscreen;
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
      if (typeof cfs != "undefined" && cfs) {
        cfs.call(el);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.accountsReceiveTotal {
  height: calc(100%);
  /*min-width: 1620px;*/
  /*min-height: 800px;*/
  /*height: 100%;*/
  text-align: left;
  overflow: auto;
  background: #ffffff;
  padding: 10px;

  .accountsReceiveTotalWrap {
    overflow: hidden;
    /*height: 100%;*/
  }

  /deep/ .el-form-item__content {
    width: calc(100% - 80px);

    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
      width: 100%;
    }
  }
  /deep/.el-input--suffix .el-input__inner {
    padding-right: 0;
  }
  .el-form-item {
    width: 100%;
  }
  .el-select {
    width: 100%;
  }
  .el-input {
    width: 100%;
  }
  .enlarge {
    display: inline-block;
    width: 40px;
    font-size: 30px;
    vertical-align: middle;
    text-align: right;

    i {
      color: #069dbc;
    }
  }

  .el-divider--horizontal {
    margin: 15px 0 5px;
  }
}
</style>

